import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from "react";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { defaultCellRangeRenderer } from "react-virtualized";
export class DataGridCellRange extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onRenderCompleteId", void 0);
  }
  shouldComponentUpdate(nextProps) {
    if (this.useDeferredScrollRendering && nextProps.params.isScrolling) {
      // This means don't do any render passes while scrolling
      return false;
    }
    if (nextProps.params.isScrolling && nextProps.params.columnStopIndex === this.props.params.columnStopIndex && nextProps.params.columnStartIndex === this.props.params.columnStartIndex && nextProps.params.rowStartIndex === this.props.params.rowStartIndex && nextProps.params.rowStopIndex === this.props.params.rowStopIndex && nextProps.dataFreshness === this.props.dataFreshness && nextProps.refreshCount === this.props.refreshCount) {
      return false;
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    this.onComponentDidUpdate();
    if (this.useDeferredScrollRendering && this.props.params.parent === this.props.dataGrid.getBodyGrid()) {
      if (!this.props.params.isScrolling && prevProps.params.isScrolling) {
        // We completed scrolling, but for reasons we don't understand the Grid is left in a half-rendered state,
        // so we are going to try to kick it in a deferred call
        requestAnimationFrame(() => this.fixupGridRendering());
      }
    }
  }
  componentWillUnmount() {
    this.clearTimeout();
  }
  render() {
    let params = this.props.params;
    let dataGrid = this.props.dataGrid;
    let mg = this.props.multiGrid;
    if (mg && mg._topRightGrid === params.parent) {
      // React Virtualized gives the top right grid an extra column when a horizontal scrollbar
      // is shown on the multigrid. We don't want to render that extra column
      params = {
        ...params,
        columnStopIndex: Math.min(params.columnStopIndex, this.props.visibleLeafColumns.length - 1)
      };
      let children = this.props.groupedHeaderCellRangeRenderer(params);
      return children;
    } else if (mg && mg._topLeftGrid === params.parent && dataGrid.frozenColumnCount > 0 && dataGrid.fixedRowCount > 1) {
      params.rowStopIndex = 0;
    } else {
      // nothing
    }

    // The very first render pass won't have the multigrid defined,
    // it needs a recompute grid size to lay the column headers out properly
    if (!mg && dataGrid.haveGroupedColumns) {
      setTimeout(() => {
        dataGrid.recomputeGridSize();
      }, 0);
    }
    return defaultCellRangeRenderer(params);
  }
  fixupGridRendering() {
    this.props.dataGrid.refreshMultiGridScrollHack();
  }
  get useDeferredScrollRendering() {
    return this.props.dataGrid.props.deferRenderingDuringScroll === true;
  }
  onComponentDidUpdate() {
    if (this.props.onRenderComplete == null) {
      return;
    }
    this.clearTimeout();
    this.onRenderCompleteId = window.requestAnimationFrame(() => {
      this.onRenderCompleteId = undefined;
      this.props.onRenderComplete();
    });
  }
  clearTimeout() {
    if (this.onRenderCompleteId !== undefined) {
      // Reset the pending timeout
      window.cancelAnimationFrame(this.onRenderCompleteId);
      this.onRenderCompleteId = undefined;
    }
  }
}
//# sourceMappingURL=DataGridCellRange.js.map
